import styled from 'styled-components';
import Link from '../Link';
import { componentToken, fontSize } from '../../style/utils';

interface LabelLinkProps {
  as?: keyof JSX.IntrinsicElements;
  size?: 'small' | 'medium' | 'large';
}

const LabelLink = styled(Link).attrs<LabelLinkProps>(({ size = 'medium' }) => ({
  size,
}))<LabelLinkProps>`
  font-size: ${({ size }) =>
    size === 'small'
      ? fontSize('sm')
      : size === 'large'
      ? fontSize('lg')
      : fontSize('base')};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};

  color: ${componentToken('link.labelColor')};

  cursor: pointer;
  text-decoration: ${({ theme }) =>
    theme.tokens.components.link.underlineOnlyOnHover ? 'none' : 'underline'};
  transition: color 0.3s ease;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }

  &:hover {
    color: ${componentToken('link.labelHoverColor')};
  }
`;

export default LabelLink;
